"use strict";

// Количество непрочитанных статей в блоге.

// сегодняшняя дата
var now = new Date();

// дата неделю назад
var weekAgo = new Date();
weekAgo.setDate(weekAgo.getDate() - 7);

var ui = {
    // Количество непрочитанных статей
    badges: document.querySelectorAll(".js-blog-unread-count"),
};

// Cache - кеш состояния блога
var Cache = function () {
    this.CACHE_KEY = "blog_state";
    this.DEFAULT_STATE = {
        // когда в последний раз проверяли количество непрочитанных статей
        // строка в формате ISO8601
        lastChecked: null,
        // когда в последний раз посещали блог
        // строка в формате ISO8601
        lastVisited: null,
        // количество непрочитанных статей
        unreadCount: 0,
    };
    this.state = this.load();
};

// load загружает состояние блога из кеша
Cache.prototype.load = function () {
    var raw = localStorage.getItem(this.CACHE_KEY);
    var state = JSON.parse(raw) || this.DEFAULT_STATE;
    state.lastVisited = state.lastVisited || weekAgo.toISOString();
    return state;
};

// save сохраняет состояние блога в кеш
Cache.prototype.save = function () {
    localStorage.setItem(this.CACHE_KEY, JSON.stringify(this.state));
};

// fetchUnreadCount загружает количество непрочитанных статей
// из вордпресса
function fetchUnreadCount(lastVisited) {
    const search = new URLSearchParams({ after: lastVisited }).toString();
    const url = `/blog/wp-json/wp/v2/posts?${search}`;
    return fetch(url)
        .then(function (response) {
            return response.json();
        })
        .then(function (response) {
            return response.length;
        })
        .catch(function (error) {
            console.log("error", error);
            return 0;
        });
}

// showUnreadCount показывает бейджик с количеством непрочитанных статей
// в меню
function showUnreadCount(unreadCount) {
    if (unreadCount == 0) {
        return;
    }
    ui.badges.forEach(function (badge) {
        badge.innerHTML = unreadCount;
        badge.classList.remove("hidden");
    });
}

// main загружает количество непрочитанных статей
// (из кеша или из вордпресса) и показывает его
function main() {
    var cache = new Cache();
    var lastDate = new Date(cache.state.lastChecked);
    var diffDays = (now - lastDate) / 1000 / 86400;
    // вызываем вордпресс не чаще, чем раз в сутки
    if (diffDays < 1) {
        console.debug("Using unread count from cache...");
        console.debug(cache.state);
        showUnreadCount(cache.state.unreadCount);
        return;
    }
    console.debug("Fetching unread count from blog...");
    fetchUnreadCount(cache.state.lastVisited).then(function (unreadCount) {
        cache.state.lastChecked = now.toISOString();
        cache.state.unreadCount = unreadCount;
        cache.save();
        showUnreadCount(cache.state.unreadCount);
        console.debug(cache.state);
    });
}

main();

export default {};
